import { List } from 'immutable';
import some from 'lodash/some';
import { createSelector } from 'reselect';

import { isResourceLoading } from './common';

const getMenu = (data) => data.get('menu', List()).toJS();

const getBottomMenuData = (state) => state.getIn(['app', 'bottomMenu']);

const isBottomMenuLoading = createSelector(getBottomMenuData, isResourceLoading);
const getBottomMenu = createSelector(getBottomMenuData, getMenu);
const isAgent360MenuAvailable = createSelector(getBottomMenu, (menu) => {
    if (!menu) {
        return false;
    }

    return some(menu, { id: 'agent360' });
});

const getMobileMenuState = (state) => state.getIn(['app', 'mobileMenu']);

const isMobileMenuLoading = createSelector(getMobileMenuState, isResourceLoading);
const getMobileMenu = createSelector(getMobileMenuState, getMenu);

const getTopMenuState = (state) => state.getIn(['app', 'topMenu']);

const isTopMenuLoading = createSelector(getTopMenuState, isResourceLoading);
const getTopMenu = createSelector(getTopMenuState, getMenu);

export {
    isBottomMenuLoading,
    isMobileMenuLoading,
    isAgent360MenuAvailable,
    isTopMenuLoading,
    getBottomMenu,
    getMobileMenu,
    getTopMenu,
};
